import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

import { sucursalActions } from '../../../../application/actions/sucursal';

import { loadersActions } from '../../../../application/actions/ui_loaders';

import api from '../../../api';

const apiSucursal = api(process.env.REACT_APP_URL);

export function* fetchSucursal(){
  try{
    const token = "123456789";

    const optionalsHeaders = {
      'Authorization': `Bearer ${token}`
    } 

    yield put(loadersActions.verificacionLoader({ isLoading: true }));

    const { data } = yield call(apiSucursal.get,  'parametro/sucursal', '', optionalsHeaders);

    yield put(loadersActions.verificacionLoader({ isLoading: false }));


    if(data){
      yield put(sucursalActions.obtenerSucursalesExito({ responseSucursal: data.data }));
    }else{
      yield put(sucursalActions.obtenerSucursalesError({ responseSucursal: { code: -1 } }));
    }
  } catch {
    yield all([
      put(sucursalActions.obtenerSucursalesError({ responseSucursal: {} }))
    ]);
  }

}

export function* saveSucursal(params){
  try{
    const token = params.payload.token ? params.payload.token : window.localStorage.getItem('track_id');
    let endpoint = '';
    let request = {};

    const optionalsHeaders = {
      'Authorization': `Bearer ${token}`,
      'track_id': token
    }

    if ('trackId' in params.payload) {
      endpoint = 'evaluacion/consulta/solicitud-finalizada';
    }

    if ('codSucursal' in params.payload) {
      endpoint = 'evaluacion/sucursal';
      request = {
        codSucursal: params.payload.codSucursal.toString(),
        codComuna: params.payload.codComuna.toString(),
        codRegion: params.payload.codRegion.toString()
      };
    }

    yield put(loadersActions.verificacionLoader({ isLoading: true }));

    const { data } = yield call(apiSucursal.post, endpoint, request, optionalsHeaders);

    yield put(loadersActions.verificacionLoader({ isLoading: false }));

    if (data && 'code' in data && data.code !== 1) {
      yield put(sucursalActions.saveSucursalSelectedSuccess({responseSaveSucursal : data}));
    } else if (data && data.code === 1) {
      yield put(sucursalActions.saveSucursalSelectedError({responseSaveSucursal : data}));
    } else {
      yield put(sucursalActions.saveSucursalSelectedError({ responseSaveSucursal: { code: -1 } }));
    }

  } catch {
    yield all([
      put(sucursalActions.saveSucursalSelectedError())
    ]);
  }
}

export function* setSucursalSelected(sucursal){
  yield put(sucursalActions.setSucursalSeleccionada(sucursal));
}

export function* watchSetSucursalSelected(){
  yield takeLatest(sucursalActions.setSucursalSeleccionada.type, setSucursalSelected);
}

export function* watchFetchSucursales(){
  yield takeLatest(sucursalActions.sucursalServicio.type, fetchSucursal);
}

export function* watchSaveSucursal(){
  yield takeLatest(sucursalActions.saveSucursal.type, saveSucursal);
}

export default function* rootSaga(){
  yield spawn([
    watchSetSucursalSelected,
    watchFetchSucursales
    
  ]);
  yield spawn(watchSaveSucursal);
}